import { SearchParams } from '@/types/common'
import {
  CreateFertigation,
  EditFertigation,
  GlobalExclusionTimeRequest,
} from '@/types/fertigation'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

const fertigationDataConfig = {
  getAll(interfaceId: string, searchParams: SearchParams = {}) {
    const url = `/api/fertigation`
    return axiosClient.get(
      url + queryStringify({ ...searchParams, interfaceId }),
    )
  },
  getById(interfaceId: number, id: number) {
    const url = `/api/fertigation/${interfaceId}/${id}`
    return axiosClient.get(url)
  },
  create(data: CreateFertigation) {
    const url = `/api/fertigation`
    return axiosClient.post(url, data)
  },
  edit(data: EditFertigation) {
    const url = `/api/fertigation`
    return axiosClient.put(url, data)
  },
  delete(interfaceId: string, id: string) {
    const url = `/api/fertigation`
    return axiosClient.delete(url, {
      params: { interfaceId: Number(interfaceId), id: Number(id) },
    })
  },
  globalExclusionTime(data: GlobalExclusionTimeRequest) {
    const url = `/api/fertigation/global-settings`
    return axiosClient.post(url, data)
  },
  getGlobalSettings(interfaceId: number) {
    const url = `/api/fertigation/global/${interfaceId}`
    return axiosClient.get(url)
  },
}

export default fertigationDataConfig
